import { useContext, useState } from "react";

import {
  Grid,
  Switch,
  FormControlLabel,
  Checkbox,
  Icon,
} from "@material-ui/core";

import TextField from "../../../../components/basics/TextFieldErp";
import Fieldset from "../../../../components/basics/Fieldset";
import Select from "../../../../components/basics/SelectErp";
import Chip from "../../../../components/basics/Chip";
import { HeaderAccordion, Line, CheckItem, Form } from "../styles/TipoServico";
import { TipoServicoContext } from "../contexts/TipoServicoContext";
import Card from "../../../../components/cards/Card";
import useTipoServicoController from "../controllers/TipoServicoController";
import Btn from "../../../../components/buttons/Btn";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import { Delete } from "@material-ui/icons";
import SearchSelectGFApi from "../../../../components/inputs/SearchSelectGFApi";
import { getNbsList } from "../../../../repositories/qerpapi/v3/main/taxation/NbsRepository";

const AccordionTipoGeral = ({ where = { uf: "SP", tipo: "2" } }) => {
  const {
    active,
    setActive,
    description,
    setDescription,
    serviceCityCode,
    setServiceCityCode,
    cnae,
    setCnae,
    errorsSubmit,
    codeNfse,
    setCodeNfse,
    codeIbpt,
    setCodeIbpt,
    companies,
    additionalData,
    setAdditionalData,
    contractSelected,
    setContractSelected,
    contractList,
    selectedNbs,
    setSelectedNbs,
  } = useContext(TipoServicoContext);

  const { handleCheckCompany, handleSelectedIbpt } = useTipoServicoController();
  const [openIbpt, setOpenIbpt] = useState(false);

  const columnsIbpt = [
    { label: "Código", id: "codigo" },
    { label: "UF", id: "uf" },
    { label: "Descrição", id: "descricao" },
    { label: "Aliquota", id: "municipal" },
  ];

  return (
    <>
      {openIbpt && (
        <SearchDialog
          open={openIbpt}
          setOpen={setOpenIbpt}
          columns={columnsIbpt}
          selectable={true}
          where={where}
          multiSelect={false}
          handleMainClick={handleSelectedIbpt}
          route="faturamento/ibpt/v1"
          filter="codigo,descricao"
          title="TABELA DE IBPT"
        />
      )}

      <Fieldset
        titulo={
          <HeaderAccordion>
            <Grid container spacing={2}>
              <Grid item xs>
                <Chip
                  label="DADOS GERAIS"
                  bgcolor="primary"
                  textcolor="white"
                />
              </Grid>
            </Grid>
          </HeaderAccordion>
        }
        bgcolor="white"
        textcolor="black"
        accordion
        defaultExpanded
      >
        <Line container spacing={2}>
          <Grid item xs>
            <TextField
              label="Descrição *"
              value={description}
              setValue={setDescription}
              size="small"
              error={errorsSubmit.description ? true : false}
              helperText={errorsSubmit.description || ""}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              label="Código de Serviço no Município *"
              value={serviceCityCode}
              setValue={setServiceCityCode}
              size="small"
              error={errorsSubmit.serviceCityCode ? true : false}
              helperText={errorsSubmit.serviceCityCode || ""}
            />
          </Grid>
          <Grid item xs={3}>
            <SearchSelectGFApi
              label="Código NBS"
              queryFn={getNbsList}
              value={selectedNbs}
              setValue={setSelectedNbs}
              getOptionLabel={(option) =>
                `${option.description} - ${option.code}`
              }
              handleRequestFilters={(text) => {
                const params = {
                  filters: {
                    description: `ilike_unaccent:${text}`,
                    code: `orWhere:ilike_unaccent:${text}`,
                  },
                };

                return params;
              }}
            />
          </Grid>
          <Grid item>
            <TextField
              label="CNAE"
              value={cnae}
              setValue={setCnae}
              size="small"
            />
          </Grid>
        </Line>
        <Line container spacing={2}>
          <Grid item xs={3}>
            <TextField
              label="Código LC.116/03"
              value={codeNfse}
              setValue={setCodeNfse}
              size="small"
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              value={codeIbpt}
              setValue={setCodeIbpt}
              label="Código Lei 12.741/12 (IBPT)"
              variant="filled"
              disabled
            />
          </Grid>
          <Grid item>
            <Btn
              label={<Icon> search</Icon>}
              full="true"
              onClick={() => setOpenIbpt(true)}
            />
          </Grid>
          {codeIbpt && (
            <Grid item>
              <Btn
                label={
                  <Delete
                    style={{
                      color: "black",
                    }}
                  />
                }
                full="true"
                bgcolor="info"
                onClick={() => {
                  setCodeIbpt("");
                }}
              />
            </Grid>
          )}
          <Grid item xs>
            <Select
              value={contractSelected}
              setValue={setContractSelected}
              optionsList={contractList}
              descriptionField="descricao"
              label="Contrato de Serviços"
            />
          </Grid>
          <Grid container xs={2} alignItems="center" justifyContent="center">
            <Grid item>
              <FormControlLabel
                label="Ativo"
                value="end"
                control={
                  <Switch
                    checked={active}
                    onChange={() => {
                      setActive((current) => !current);
                    }}
                    color="primary"
                    onClick={(event) => event.stopPropagation()}
                    onFocus={(event) => event.stopPropagation()}
                  />
                }
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12}>
              <TextField
                value={additionalData}
                setValue={setAdditionalData}
                label="Dados Adicionais"
                multiline
                rows={6}
                variant="filled"
              />
            </Grid>
          </Grid>
        </Line>
        {companies.length > 1 && (
          <Card line="left" padding="10" fullWidth>
            <Grid container>
              <Chip title label="Empresas" bgcolor="secondary" />
            </Grid>
            <Grid container>
              <Form>
                {companies.map((company) => (
                  <CheckItem
                    key={company.id}
                    control={
                      <Checkbox
                        checked={company.check}
                        onChange={() => {
                          handleCheckCompany(company.id);
                        }}
                      />
                    }
                    label={company.apelido}
                  />
                ))}
              </Form>
            </Grid>
          </Card>
        )}
      </Fieldset>
    </>
  );
};

export default AccordionTipoGeral;
